import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-553b1f35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "allBlockWidth" }
const _hoisted_2 = { class: "items-in-line" }

import { onMounted, ref, Ref, watch } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ErrorsType } from '@/types';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { useCompareStore } from '@/store/modules/compare';

type FormDataType = {
  name: string | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeCompareTitleModal',
  props: {
    showModal: { type: Boolean },
    compareId: {},
    compareName: {}
  },
  emits: ['close', 'updateSuccessMessage'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const formData: Ref<FormDataType> = ref({
  name: undefined,
});

const clearFormData = () => {
  v$.value.$reset();
  errors.value = {};
  for (const [key] of Object.entries(formData.value)) {
    formData.value[key as keyof FormDataType] = undefined;
  }
};
const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  name: { required },
};

const v$ = useVuelidate<FormDataType>(rules, formData);
const errors: Ref<ErrorsType> = ref({});

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const loading = ref(false);
const formSubmit = async () => {
  if (v$.value.$invalid || !formData.value.name) {
    v$.value?.$touch();
    validationErrorsHandler();

    return;
  }

  loading.value = true;
  try {
    const res = await useCompareStore().updateCompareName({
      id: props.compareId,
      name: formData.value.name,
    });

    if (res) {
      emit('updateSuccessMessage', {
        message: 'Успешно сохранено',
      });
      clearFormData();
      closeModal();
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};

const closeModal = () => {
  emit('close');
};

onMounted(() => {
  formData.value.name = props.compareName;
});
watch(
  () => props.compareName,
  () => {
    formData.value.name = props.compareName;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.showModal,
    title: "Изменить название",
    onClose: closeModal
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_base_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
              error: errors.value.name,
              invalid: !!errors.value.name,
              label: "Введите название",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('name'))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.name)),
              onInput: _unref(v$).name?.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"])
          ]),
          _: 1
        })
      ])
    ]),
    btn: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_button, {
          "style-type": "coloredBorder",
          text: "Отмена",
          width: "100",
          onClick: closeModal
        }),
        _createVNode(_component_base_button, {
          loading: loading.value,
          text: "Сохранить",
          width: "100",
          onClick: formSubmit
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["show-modal"]))
}
}

})